import  React,{ useState } from "react";

import { Grid, Form, Dropdown, Button } from "semantic-ui-react";

import { useSelector, useDispatch } from "react-redux";
import { setLang } from "../../config/i18n/slice";
import { selectTranslations } from "../../config/i18n/slice";
import { useHistory } from "react-router-dom";
import { setCookie } from "../../config/common/commonFunctions";
import { updateUserLanguage } from "../../config/api/peopleApis";
export const Settings = () => {
  const t = useSelector(selectTranslations);
  const user = useSelector((state) => {
    if (state?.auth?.user) {
      return state.auth.user;
    } else {
      return null;
    }
  });
  const lang = useSelector((state) => state.i18n.lang);
  const supportedLangs = useSelector((state) => state.i18n.supportedLangs);
  const history = useHistory();
  const dispatch = useDispatch();
  const [dropdownOptions, setDropdownOptions] = useState({
    lang: Object.entries(supportedLangs).map(([code, name]) => {
      return {
        key: code,
        value: code,
        text: name,
      };
    }),
  });

  const handleLanguageUpdate = async (value) => {
    let res = await updateUserLanguage(
      user?.id,
      value.value == "ar" ? "Arabic" : "English"
    );
    if (res && res.status == 200) {
      dispatch(setLang(value.value));
      setCookie("LANG", value.value, 10);
    }
  };

  const userRole = useSelector((state) => {
    if (state?.auth?.user?.role?.type) {
      return state?.auth?.user?.role?.type;
    } else {
      return "";
    }
  });

  return (
    <div className="ml-5 mr-5">
      <div
        className={
          userRole == "super_admin"
            ? "table-header-dashbaord list-view-option-setting mt-5"
            : "table-header-dashbaord list-view-option-setting mb-5 mt-5"
        }
      >
        <Button.Group
          className={`add-people-btn ${userRole === "super_admin" ? "company":"language"}`}
          basic
          fluid
      
          size="medium"
        >
          {userRole == "super_admin" ? (
            <Button
              type="button"
              onClick={() => history.push("/company-profile")}
            >
              {t.common.company_profile}
            </Button>
          ) : null}

          <Button type="button" active={true}>
            {t.common.language}
          </Button>
        </Button.Group>
      </div>

      <Grid className="mt-0" columns="equal">
        <Grid.Column className="pt-0">
          <Form.Field>
            <label className="mt-5">{t.common.language}</label>
            <Dropdown
              fluid
              selection
              noResultsMessage={t.common.no_results_found}
              options={dropdownOptions.lang}
              value={lang}
              placeholder="Select Language"
              onChange={(event, value) => {
                handleLanguageUpdate(value);
              }}
            />
          </Form.Field>
        </Grid.Column>
        <Grid.Column></Grid.Column>
      </Grid>
    </div>
  );
};
